<template>

 <v-dialog max-width="600px" v-model="showDialog">
    <v-btn flat fab slot="activator" style='margin-top:-20px' 
        class="indigo accent-1"
        light small mt-4 absolute middle right ><v-icon>edit</v-icon></v-btn>

    <v-card>
      <v-card-title>
        <h2>Either edit cemetery name or merge into another cemetery</h2>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
            <v-layout row>
              <v-flex xs12>
                <v-text-field  v-if="showDialog" autofocus v-model="edittedCemetery.name" name='cemeteryName' label="Cemetery Name"
                  :rules="[rules.required, rules.min]" />
              </v-flex>
            </v-layout>

            <v-layout col justify-start>
              <v-flex xs2 pt-3  mx-2>
                <label class='prompt'>Cemetery Location</label>
              </v-flex>
              <v-flex xs10>
                <v-layout row>
                  <v-flex xs8 mx-2>
                    <v-autocomplete  v-model="cp.select" :items="cp.places" item-text="pn" item-value="id"
                      :search-input.sync="cpSearch" :loading="cp.loading" single-line  return-object @change="placeChange()">     
                    </v-autocomplete>
                  </v-flex> 
                </v-layout>               
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs4>
                <div class="text-xs-left">
                <v-btn  flat outline color="black" @click='showMerge'>
                  <v-icon small left>arrow_right_alt</v-icon>
                 <span>Merge into another Cemetery</span>
                </v-btn>               
                </div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if='showingMerge'>
              <v-flex xs12 my-3 py-3>
                <div style="margin-top:-30px;border:1px solid white">
                  <div class="grey--text" style='text-align:left'>All the people assigned to the current cemetery "{{edittedCemetery.name}}"" 
                        will be moved to the new cemetery you choose, and the current cemetery will cease to exist.                         
                  </div> 
                  <v-autocomplete v-model="mergeCemetery.select" :items="mergeCemetery.cemeteries" item-text="n" item-value="id" label="Search for a  cemetery to merge into"
                          :search-input.sync="mergeCemeterySearch" :loading="mergeCemetery.loading" single-line return-object @change="mergeCemeteryChange()">     
                        </v-autocomplete>  
                  </div>
                  <v-btn flat outline color="black" @click='hideMerge'>
                        <v-icon small left>cancel</v-icon>
                        <span>Cancel merge</span>
                  </v-btn> 
              </v-flex>
            </v-layout>
 
           <provenance-and-note v-bind:record="edittedCemetery"/>

          <v-layout row>
            <v-flex xs12>
              <div class="danger-alert" v-html="error"></div>
            </v-flex>
          </v-layout>

          <v-layout row>          
            <v-flex xs2>
            </v-flex>
            <v-flex xs8>
              <v-btn dark class="indigo darken-1" @click='editCemetery' :loading="loading"><v-icon left >save_alt</v-icon>{{editButtonPrompt}}</v-btn>
            </v-flex>
            <v-flex xs2>
            </v-flex>
          </v-layout>

        </v-form>
      </v-card-text>
    </v-card>
 </v-dialog>    
</template>        

<script>

import Panel from '@/components/Panel' ;
import CemeteryService from "@/services/CemeteryService" ;
import PlaceService from "@/services/PlaceService" ;

export default {
  components: { Panel, PlaceService },     

  data () {
    return {
      cemetery: {},
      edittedCemetery: {  
        id: parseInt(this.$route.params.id),
        name: '',
        provenance: '',
        note: '',
        mergedToCemeteryId: -1,
        newPlaceId: -1
      },
      error: null,
      message: null,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Minimum of 8 characters is required.'
      },

      mergeCemetery: {  
        name: '',        
        select: {id: -1, n: ""},
        cemeteries: [],
        loading: false,        
        pendingSearch: null
      },
      mergeCemeterySearch: null, 

      showingMerge: false,
      editButtonPrompt: "Change Cemetery Name and/or Location",
      loading: false,
      showDialog: false,

      cp: {
        select: {id: -1, pn: ""}, 
        places: [],
        loading: false,
        origId: -1,
        nextSearchFor: null
      },
      cpSearch: null   
    }
  },

  async mounted () {
    console.log("in cemeteryedit mounted") ;
    await this.readData() ;
  },
  watch: {
    async mergeCemeterySearch (val) {
      if (val && val !== this.mergeCemetery.select.n && (val.length >= 2)) {
        this.mergeCemetery.select.id = -1 ;
        this.runMergeCemeterySearch(val, this.mergeCemetery) ;
      }
    },
    async cpSearch (val) {
      console.log("IN CP SEARCH val: " + val + ", this.cpSelect.pn=" + this.cp.select.pn) ;
      if (val && val !== this.cp.select.pn && (val.length >= 2)) {
        this.runPlaceSearch(val, this.cp) ;
      }
    }, 
    cemetery: function (val) {
      // this.person = val ;
      this.updateCP() ;
    }      
  },  

  methods: {
    updateCP () {
      console.log(" in UPDATECP, this.cemetery=" + JSON.stringify(this.cemetery)) ;
      this.updatePlace(this.cp, this.cemetery.place) ;
    },
    updatePlace (locp, dbp) {

      if (dbp && dbp) {
        locp.select.id = -1 ; 
        if (dbp.town) {
          locp.select.id = dbp.town.id ;
          locp.select.pn = dbp.town.v ;
          if (dbp.state) locp.select.pn += ", " + dbp.state.v ;
          if (dbp.country) locp.select.pn += ", " + dbp.country.v ;
        }
        else if (dbp.state) {
          locp.select.id = dbp.state.id ;
          locp.select.pn = dbp.state.v ;
          if (dbp.country) locp.select.pn += ", " + dbp.country.v ;
        }
        else if (dbp.country) {
          locp.select.id = dbp.country.id ;
          locp.select.pn = dbp.country.v ; 
        }
        else {
          locp.select.id = -1 ; 
          locp.select.pn = "" ; 
        }
        locp.origId =  locp.select.id ;
        locp.places = [ locp.select ] ;
        console.log("Set this.cpPlaces=" + JSON.stringify(locp.places)) ;
      }
    }, 

    async placeChange () {
      console.log("---------------------------------C: " + JSON.stringify(this.cp.select)) ;
      this.edittedCemetery.newPlaceId = this.cp.select.id ;
    },
    async runPlaceSearch (val, locp) {

      console.log("runPlaceSearch val: " + val) ;
      if (locp.loading) {
        locp.pendingSearch = val ;
        console.log("PENDING SEARCH QUEUED: " + val) ;
        return ;
      }
      locp.loading = true ;
      try {
        const response = await PlaceService.placeFindMatchesOnName(val, true) ;
        console.log("PlaceService responsed") ; // + JSON.stringify(response)) ;

        locp.places = response.data ;
      }
      catch (err) {
        console.log("placeQuerySelections catch err:" + JSON.stringify(err)) ;
        this.error = err.response.data.error  ;
      }
      finally {
        locp.loading = false ;
        if (locp.pendingSearch) {
          const queuedSearch = locp.pendingSearch ;
          locp.pendingSearch = null ;
          console.log("Queuing pending search.." + queuedSearch) ;
          this.runPlaceSearch(queuedSearch, locp) ;
        }
      }
    },

    async editCemetery () {
      console.log("IN editCemetery") ; 
      this.error = null ;
      if (this.showingMerge) {
        if (this.edittedCemetery.mergeToCemeteryId <= 0) {
          this.error = "Select a cemetery to merge this cemetery into" ;
          return ;
        }
        console.log("mergeToCemetery=" + JSON.stringify(this.edittedCemetery.mergeToCemeteryId)) ;
        try {
          console.log("at 1") ;
          this.loading = true ;
          const response = await CemeteryService.mergeTo(this.edittedCemetery) ;
          console.log("at 2") ;
          console.log("mergeTo response: " + JSON.stringify(response)) ;

          // this.message = response.data.message
          console.log("success mergeTo, resp data=" + JSON.stringify(response.data)) ;
          this.showDialog = false ;
          this.$store.dispatch('setPendingMessage', {text: "Cemetery " + this.edittedCemetery.name + " merged and deleted", color: 'success'}) 
          this.$router.push('/cemetery/' + response.data.id) ;
        }
        catch (err) {
          console.log("catch err:" + JSON.stringify(err)) ;
          // console.log("ee=" + err.response.data.error)

          this.error = err.response.data.error  ;
        }
        finally {
          this.loading = false ;
        }
        return ;
      }

      // otherwise, a name change..

      try {
        this.loading = true ;
        const response = await CemeteryService.edit(this.edittedCemetery) ;
        console.log("editCemetery response: " + JSON.stringify(response)) ;

        // this.message = response.data.message
        console.log("success edit, resp data=" + JSON.stringify(response.data)) ;
        this.showDialog = false ;        
        this.$renderToastInParent(this, "Cemetery name successfully changed") ;
        // this.$router.push('/cemetery/' + response.data.id) ;
      }
      catch (err) {
        console.log("catch err:" + JSON.stringify(err)) ;
        // console.log("ee=" + err.response.data.error)

        this.error = err.response.data.error  ;
      }
      finally {
        this.loading = false ;
      }      
    },

    async readData () {
      const result = await CemeteryService.id(this.edittedCemetery.id) ;
      this.cemetery = result.data ;
      console.log("Back from us, this.cemetery=" + JSON.stringify(result)) ;
      this.edittedCemetery.name = this.cemetery.name ;
    },

    async mergeCemeteryChange () {
      console.log("---------------------------------mergeCemeteryChange: " + JSON.stringify(this.mergeCemetery.select)) ;
      this.edittedCemetery.type = 'merge' ;
      this.edittedCemetery.mergedToCemeteryId = this.mergeCemetery.select.id ;
    },

    async runMergeCemeterySearch (val, locp) {

      console.log("runMergeCemeterySearch val: " + val) ;
      if (locp.loading) {
        locp.pendingSearch = val ;
        console.log("PENDING SEARCH QUEUED: " + val) ;
        return ;
      }
      locp.loading = true ;
      try {
        const response = await CemeteryService.findMatchesOnName(val, "count") ;
        console.log("CemeteryService responsed") ; // + JSON.stringify(response)) ;

        locp.cemeteries = response.data ;
      }
      catch (err) {
        console.log("runMergeCemeterySearch catch err:" + JSON.stringify(err)) ;
        this.error = err.response.data.error  ;
      }
      finally {
        locp.loading = false ;
        if (locp.pendingSearch) {
          const queuedSearch = locp.pendingSearch ;
          locp.pendingSearch = null ;
          console.log("Queuing pending search.." + queuedSearch) ;
          this.runMergeCemeterySearch(queuedSearch, locp) ;
        }
      }
    },

    showMerge () {
      console.log("showMerge clicked") ;
      this.showingMerge = true ;
      this.editButtonPrompt = "Merge (and then delete) Cemetery" ;
    },
    hideMerge () {
      this.showingMerge = false ;
      this.editButtonPrompt = "Change Cemetery Name and/or Location" ;
      this.mergeToCemetery = null ;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CemeteryEdit.vue